module.exports = __webpack_public_path__ + "static/apple-e52159966a03cbd6798f85817dde265a.png";